
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PreparednessHero from './components/PreparednessHero';
import StatsBar from './components/StatsBar';
import InteractiveChecklist from './components/InteractiveChecklist';
import StorageTips from './components/StorageTips';
import FamilyPlan from './components/FamilyPlan';
import ResourcesCTA from './components/ResourcesCTA';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';

export default function PreparednessPage() {
  useSEO({
    title: 'Emergency Preparedness Checklist | Roseville CA Disaster Readiness | Roseville.org',
    description: 'Build your emergency kit and create a family plan with our interactive checklist. Be prepared for earthquakes, wildfires, and other emergencies in Roseville, CA. Includes supply lists, storage tips, and family communication plans.',
    keywords: 'Roseville emergency preparedness, disaster readiness Roseville CA, emergency kit checklist, wildfire preparedness Roseville, earthquake preparedness Placer County',
    canonical: '/preparedness',
    ogImage: 'https://public.readdy.ai/ai/img_res/6d0d9b05060aebecfeffa2de1b6d71fa.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          name: 'Emergency Preparedness — Roseville, California',
          description: 'Interactive emergency preparedness checklist and family planning guide for Roseville, CA residents.',
          url: `${import.meta.env.VITE_SITE_URL || 'https://roseville.org'}/preparedness`,
          inLanguage: 'en-US',
        },
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Emergency Resources', url: '/emergency' },
          { name: 'Preparedness', url: '/preparedness' },
        ]),
        {
          '@type': 'HowTo',
          name: 'How to Build an Emergency Preparedness Kit in Roseville, CA',
          description: 'Step-by-step guide to building an emergency kit and family plan for Roseville residents.',
          step: [
            { '@type': 'HowToStep', name: 'Gather emergency supplies', text: 'Collect water, food, first aid, and essential documents.' },
            { '@type': 'HowToStep', name: 'Create a family communication plan', text: 'Establish meeting points and out-of-area contacts.' },
            { '@type': 'HowToStep', name: 'Know your evacuation routes', text: 'Identify primary and alternate evacuation routes from your neighborhood.' },
            { '@type': 'HowToStep', name: 'Sign up for emergency alerts', text: 'Register for Placer County emergency notification system.' },
          ],
        },
      ],
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <PreparednessHero />
        <StatsBar />
        <InteractiveChecklist />
        <StorageTips />
        <FamilyPlan />
        <ResourcesCTA />
      </main>
      <Footer />
    </div>
  );
}
